// Material UI
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select'
import Input from '@mui/material/Input';
import { Grid } from '@mui/material';

// External
import NumberFormat from 'react-number-format';

// Owned
import { DONATION_TYPES } from './Constants';

const DonationOptions = (props) => {
    
    const handleCurrencyChange = (event) => {
        props.setCurrency(event.target.value);
    }

    const handleValueChange = (event) => {
        props.setDonationValue(event.target.value);
    }

    const handleTypeChange = (event) => {
        props.setDonationType(event.target.value);
    }

    const clearCustomValue = () => {
        props.setCustomValue(null);
    }

    return (
        <div>
            <br/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl>
                        <FormLabel id="currency-value">Currency</FormLabel>
                        <Select
                            labelId="currency-label"
                            id="currency-select"
                            value={props.currency}
                            label="Currency"
                            onChange={handleCurrencyChange}
                        >
                            <MenuItem value={"$ USD"}>$ USD</MenuItem>
                            <MenuItem value={"€ EUR"}>€ EUR</MenuItem>
                            <MenuItem value={"£ GBP"}>£ GBP</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl>
                        <FormLabel id="donation-value">Amount ({props.currency})</FormLabel>
                        <RadioGroup
                        row
                        name="donation-value-radio-group"
                        value={props.donationValue}
                        onChange={handleValueChange}
                    >
                            <FormControlLabel value="10" control={<Radio />} label={"10 " + props.currency.split(" ")[0]} onFocus={clearCustomValue} />
                            <FormControlLabel value="15" control={<Radio />} label={"15 " + props.currency.split(" ")[0]} onFocus={clearCustomValue} />
                            <FormControlLabel value="20" control={<Radio />} label={"20 " + props.currency.split(" ")[0]} onFocus={clearCustomValue} />
                            <FormControlLabel value="35" control={<Radio />} label={"35 " + props.currency.split(" ")[0]} onFocus={clearCustomValue} />
                            <FormControlLabel value="50" control={<Radio />} label={"50 " + props.currency.split(" ")[0]} onFocus={clearCustomValue} />
                            <FormControlLabel value="custom" control={<Radio />} label="Custom Amount" />
                            {props.donationValue === 'custom' ? 
                                <div>
                                    <NumberFormat 
                                        value={props.customValue}  
                                        displayType="input"
                                        type="text"
                                        thousandSeparator={true} 
                                        allowNegative={false}
                                        onValueChange={(values) => {
                                            props.setCustomValue(values.value);
                                          }}
                                        prefix={props.currency.split(" ")[0]} 
                                        customInput={Input}
                                    />
                                </div>
                            : null}
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl>
                        <FormLabel id="donation-value">Frequency</FormLabel>
                        <RadioGroup
                        row
                        name="donation-value-radio-group"
                        value={props.donationType}
                        onChange={handleTypeChange}
                        >
                            <FormControlLabel value={DONATION_TYPES.ONE_TIME} control={<Radio />} label="Single Donation" />
                            <FormControlLabel value={DONATION_TYPES.MONTHLY} control={<Radio />} label="Monthly Donation" />
                            <FormControlLabel value={DONATION_TYPES.YEARLY} control={<Radio />} label="Yearly Donation" />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </div>
    );
}

export default DonationOptions;